// LMS Logs translations for React Admin resource
export const lmsLogsResource = {
  name: 'LMS 日誌',
  fields: {
    id: 'ID',
    decisionTimestamp: '決策時間',
    triggerReason: '觸發原因',
    loadGroup: '負載組',
    ocppServer: 'OCPP 伺服器',
    allocationStrategy: '分配策略',
    chargers: '充電樁',
    powerAllocation: '功率分配',
    profiles: '充電配置',
    executionTime: '執行時間',
    details: '詳細資訊',
    activeChargers: '活躍充電樁',
    pendingChargers: '等待充電樁',
    totalRequestedCurrent: '請求電流',
    availableCurrent: '可用電流',
    utilizationPercent: '使用率 %',
    totalAllocatedCurrent: '分配電流',
    profilesSent: '發送配置',
    profilesAccepted: '接受配置',
    profilesRejected: '拒絕配置',
    executionTimeMs: '執行時間 (毫秒)',
    error: '錯誤',
    loadGroupId: '負載組 ID',
    ocppServerId: 'OCPP 伺服器 ID',
    triggerDetails: '觸發詳情',
    allocations: '分配詳情',
  },
};

// Custom LMS logs translations for components
export const lmsLogs = {
  subtitle: '檢視負載管理系統決策日誌和功率分配歷史記錄',
  list: {
    title: 'LMS 決策日誌',
    filters: {
      search: '搜尋',
      triggerReason: '觸發原因',
      allocationStrategy: '分配策略',
      loadGroupId: '負載組 ID',
      ocppServerId: 'OCPP 伺服器 ID',
      startDate: '開始日期',
      endDate: '結束日期',
    },
    empty: {
      title: '未找到 LMS 日誌',
      subtitle: '負載管理開始後，LMS 決策日誌將顯示在這裡。',
    },
  },
  triggers: {
    SESSION_START: '時段開始',
    SESSION_STOP: '時段停止',
    STATUS_CHANGE: '狀態變更',
    PERIODIC: '定期重新平衡',
    MANUAL: '手動觸發',
  },
  strategies: {
    equal: '平均分配',
    equal_distribution: '平均分配',
    queue: '隊列 (先到先服務)',
    member_priority: '會員優先',
  },
  chargers: {
    active: '{{count}} 個活躍',
    pending: '{{count}} 個等待',
  },
  profiles: {
    success: '{{accepted}}/{{sent}} ({{rate}}%)',
    rejected: '{{count}} 個被拒絕',
  },
  status: {
    success: '成功',
    error: '錯誤',
    partial: '部分成功',
  },
  details: {
    noDetails: '無詳細資訊',
    charger: '充電樁：{{id}}',
    inefficiency: '低效率：{{percent}}%',
    transaction: '交易：{{id}}',
    statusChange: '{{oldStatus}} → {{newStatus}}',
  },
  notifications: {
    exportSuccess: 'LMS 日誌導出成功',
    exportError: '導出 LMS 日誌失敗',
  },
  powerInfo: {
    allocated: '已分配',
    available: '可用',
    requested: '請求',
    utilization: '使用率',
  },
  show: {
    title: 'LMS 決策詳情',
    basicInfo: '基本資訊',
    triggerDetails: '觸發詳情',
    noAllocations: '此決策中未進行功率分配',
    chargerStation: '充電樁 / 站點',
    currentLimit: '電流限制',
    reductionFactor: '降低係數',
    loadGroupInfo: '負載組資訊',
    powerAllocation: '功率分配',
    chargerStats: '充電樁統計',
    activeChargers: '活躍充電樁',
    allocated: '已分配電流',
    currentAllocation: '當前分配',
    utilization: '使用率',
    profileStats: '充電配置',
    allocations: '功率分配',
    errorDetails: '錯誤詳情',
  },
};